import {ActivityWindow, DomWindow, DomWindowConfig} from './DomWindow';
import {bringToFront, MessageBar, MessageBarAction, ProgressBar, SearchableMenu, ShowRelTimePicker} from './DomMenu';
import { Memo, MemoItem } from './Memo';
import sanitizeHtml from 'sanitize-html';
import {EL, bufferToBase64, renderIcon2, dragdrop1d, keyname, mkStyleSheet} from './util/DomUtils';
import {
    SearchMatcher,
    compareObjects,
    compareObjectsVerbose,
    debounced,
    deepEqual,
    bufferToHex, hexToBuffer, retry
} from './util/CoreUtils';
import { MemoItemSearchMatcher } from './util/AppUtils';
import {GridCtrl, ObjectTreeCtrl, TreeCtrl} from './GridCtrl';
import {idbGet, idbPut, idbSearch, idbWrapRequest, openDb} from './util/IDBUtils';
import { ScriptHost } from './ScriptHost';
import {makeParser, WaxeyeCompiler, WaxeyeParser} from './util/expr/WaxeyeHelper';
import {BaseExpression, Expression, ExprParser, LambdaExpression, transform, visitResult} from './util/expr/Expr';
import {RpcBroker, RpcSession, signal, WebSocketRpcClient} from "./lib";
import {App} from "./PinboardApp";
import {Terminal} from '@xterm/xterm';
import {FitAddon} from '@xterm/addon-fit';
import {Action, Command} from "./ActionManager";
import {LocalMruList, MruList, SyncedMruList} from "./util/MruList";

import "@xterm/xterm/css/xterm.css";
import Coloris from "@melloware/coloris";
import Ajv from 'ajv';
import $ from 'jquery';
import {dumpRpcMessage} from "./lib/rpc/rpc";
import {Activity, ImmutableActivity} from "./ui/Activity";
import {ActivityHolder} from "./ui/ActivityHolder";
import {InMemoryDocument, ReadonlyDocument} from "./db/WritableDocument";

export const PinboardObjectApi = {
    util: {
        // legacy
        DomWindow: DomWindow,
        DomWindowConfig: DomWindowConfig,
        SearchableMenu: SearchableMenu,
        MessageBar: MessageBar,
        ProgressBar: ProgressBar,

        // dom util
        EL: EL,
        sanitizeHtml: sanitizeHtml,
        renderIcon2: renderIcon2,
        dragdrop1d: dragdrop1d,
        keyname: keyname,
        mkStyleSheet: mkStyleSheet,

        // lang
        SearchMatcher: SearchMatcher,
        MemoItemSearchMatcher: MemoItemSearchMatcher,
        Expression,
        LambdaExpression,
        BaseExpression,

        //
        bufferToBase64: bufferToBase64,
        hexToBuffer, bufferToHex,
        debounced: debounced,
        deepEqual: deepEqual,
        compareObjectsVerbose: compareObjectsVerbose,
        compareObjects: compareObjects,

        // idb util
        idb: { openDb, idbGet, idbPut, idbSearch, idbWrapRequest },

        // rpc
        rpc: {
            RpcBroker: RpcBroker<{ session: RpcSession }>,
            WebSocketRpcClient,
        },

        // MruList
        MruList, LocalMruList, SyncedMruList,
    },
    lib: {
        signal: signal,
    },
    ui: {
        DomWindow: DomWindow,
        DomWindowConfig: DomWindowConfig,
        SearchableMenu: SearchableMenu,
        MessageBar: {
            show: (type: string, message: string, timeout?: number, actions: MessageBarAction[] = [], ...params: any) => PinboardObjectApi.app.toast(type, message, timeout, actions, params),
            hide: MessageBar.hide,
        },
        ProgressBar: ProgressBar,
        TreeCtrl: TreeCtrl,
        ObjectTreeCtrl: ObjectTreeCtrl,
        GridCtrl: GridCtrl,
        ShowRelTimePicker: ShowRelTimePicker,
        CodeMirrorWindow: undefined as any,
        Action, Command,
        bringToFront: bringToFront,
        Activity: Activity,
        ActivityHolder: ActivityHolder,
        ActivityWindow: ActivityWindow,
        ImmutableActivity: ImmutableActivity,
    },
    core: {
        Memo: Memo,
        MemoItem: MemoItem,
        ScriptHost: ScriptHost,
        db: {
            ReadonlyDocument: ReadonlyDocument,
            InMemoryDocument: InMemoryDocument,
        },
    },
    app: null as App | null,
    _miratest: {
        ExprParser,
        makeParser,
        transform,
        visitResult,
        dumpRpcMessage,
    },
    vnd: {
        XtermJS: { Terminal: Terminal, FitAddon: FitAddon },
        Coloris,
        Ajv,
        JQuery: $,
        Waxeye: {WaxeyeParser, WaxeyeCompiler},
    },
    import: async function(id) {
        const [documentId, item] = id.split('#');

        const doc = await retry(10, 1000, () => {
            const doc = this.app.findMemoWithDocument(documentId, false);
            if (!doc)
                throw new Error("Document "+documentId+" not loaded");
            return doc;
        });

        const memoitem = await retry(10, 1000, () => {
            if (!doc.items[item]) throw new Error("Item "+id+" not found");
            return doc.items[item];
        });


        return await memoitem.getScriptResult();
    }
};